import { INDUSTRIES } from '@/landing/content'
import { ContentPage, contentMeta, type ContentPageData } from '@/site/content'

const food = INDUSTRIES.find((i) => i.key === 'food')!

const page: ContentPageData = {
  path: '/funktsii/zayavky-v-telegram',
  parent: { name: 'Можливості', path: '/funktsii' },
  crumb: 'Заявки в Telegram',
  title: 'Заявки з дзвінків у Telegram за секунди | Anytel',
  description:
    'Після кожного дзвінка заявка чи запис приходять у Telegram менеджеру: ім’я, телефон, що потрібно клієнту. Сповіщення на пошту й у CRM теж працюють.',
  eyebrow: 'Можливості',
  h1: 'Заявки з дзвінків у Telegram',
  lead:
    'Клієнт поклав трубку, а у вашому Telegram уже повідомлення: хто дзвонив, що хоче і на коли записаний. Менеджеру не треба сидіти в кабінеті, щоб нічого не пропустити.',
  sections: [
    {
      h2: 'Що приходить у Telegram',
      blocks: [
        {
          list: [
            'Нова заявка: ім’я, телефон, суть звернення і все, що агент зібрав у розмові.',
            'Новий запис у календар: хто, до кого, на коли.',
            'Попередження, що пакет хвилин використано на 80% і на 100%.',
          ],
        },
      ],
    },
    {
      h2: 'Кому надсилати',
      blocks: [
        'Сповіщення налаштовуються в кабінеті: можна додати кількох отримувачів і для кожного обрати канал, Telegram або пошту. Наприклад, у спільний чат адміністраторів і окремо власнику на пошту.',
        'Повідомлення надсилає бот Anytel, тож особисті номери вашої команди ніде не світяться, а відключити отримувача можна в кабінеті в будь-який момент.',
      ],
    },
    {
      h2: 'Коли це особливо зручно',
      blocks: [
        {
          list: [
            'Власник хоче бачити кожну заявку, але не сидіти в кабінеті: повідомлення приходить туди, де він і так читає новини й робочі чати.',
            'Майстри на виїзді чи в боксі: заявка з адресою й описом проблеми вже в телефоні, передзвонити можна одним дотиком.',
            'Кілька філій: кожна отримує свої заявки у свій чат, якщо кожній філії відповідає окремий номер і сценарій.',
            'Нічні дзвінки: усе, що агент прийняв після закриття, зранку чекає в одному чаті, а не розкидане по пропущених.',
          ],
        },
      ],
    },
    {
      h2: 'Чому саме Telegram',
      blocks: [
        'Бо він уже відкритий на телефоні в кожного менеджера. Сповіщення приходить за секунди, з ним можна працювати з будь-якого місця: передзвонити клієнту, переслати колезі, відповісти в чаті «беру». Кабінет лишається для деталей: запису розмови, тексту, історії клієнта.',
        'Telegram, кабінет і CRM не замінюють одне одного. Telegram потрібен, щоб швидко помітити заявку. Кабінет, щоб побачити все про дзвінок і клієнта. CRM, щоб вести угоду далі. Заявка потрапляє в усі три місця одночасно, і ніхто нічого не переписує вручну.',
      ],
    },
    {
      h2: 'Звідки беруться заявки',
      blocks: [
        'Заявку створює сценарій дзвінка: після розмови з [AI-агентом](/funktsii/ai-agent-dlya-dzvinkiv), після вибору в голосовому меню або коли клієнт залишив номер у віджеті «Передзвоніть мені» на сайті. Заявки з чатів у месенджерах приходять туди ж.',
        'Статус заявки (нова, зв’язалися, підтверджена, скасована) змінюється в кабінеті, а через [вебхуки](/funktsii/integratsiya-z-crm) ці зміни потрапляють і у вашу CRM.',
      ],
    },
  ],
  dialog: {
    h2: 'Приклад: бронювання, яке менеджер побачив у Telegram',
    context: 'Ресторан, субота, 18:05',
    dialog: food.dialog,
    result: food.result,
  },
  after: [
    {
      h2: 'Як налаштувати',
      blocks: [
        {
          steps: [
            { title: 'Отримувачі', text: 'У налаштуваннях сповіщень оберіть Telegram і вкажіть, куди надсилати: особистий чат чи групу.' },
            { title: 'Перевірка', text: 'Зробіть тестовий дзвінок з браузера, залиште заявку і подивіться, як вона прийде.' },
          ],
        },
      ],
    },
  ],
  faq: [
    {
      q: 'Чи можна отримувати заявки на пошту?',
      a: 'Так. Для кожного отримувача обирається канал: Telegram або пошта.',
    },
    {
      q: 'Скільки людей можуть отримувати сповіщення?',
      a: 'Скільки потрібно: додайте кількох отримувачів або груповий чат.',
    },
    {
      q: 'Чи видно в Telegram запис розмови?',
      a: 'У повідомленні суть заявки. Запис розмови і її текст відкриваються в кабінеті, у деталях дзвінка.',
    },
    {
      q: 'А Viber?',
      a: 'Сповіщення для команди зараз приходять у Telegram і на пошту. Клієнтам же агент відповідає і у Viber, Instagram та Messenger.',
    },
  ],
  related: ['/funktsii/integratsiya-z-crm', '/funktsii/ai-agent-dlya-dzvinkiv', '/dlya/restoraniv-i-dostavky', '/dlya/saloniv-krasy'],
}

export const meta = contentMeta(page)

export default function Page() {
  return <ContentPage page={page} />
}
